import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useFileExplorerContext } from './useFileExplorerContext';
import { getFileExplorerQueryKey } from '../utils/fileExplorer';

interface FileExplorerMutationError {
  reason: string;
  description: string;
}

export function useFileExplorerMutation<T>({
  mutationFn, onSuccess,
}: { mutationFn: (args: T) => Promise<unknown>; onSuccess?: (response: unknown) => void }) {
  const { activeFolder } = useFileExplorerContext();
  const queryKey = getFileExplorerQueryKey(activeFolder?.id);
  const queryClient = useQueryClient();

  const mutation = useMutation<unknown, AxiosError<FileExplorerMutationError>, T>({
    mutationFn,
    onSuccess: async (response) => {
      onSuccess?.(response);
      await queryClient.invalidateQueries({ queryKey: [queryKey] });
    },
  });

  return mutation;
}
